import React, { FC } from 'react';

import { IconProps } from 'types/components';

import Icon from './Icon';

const Calendar: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path d="M8 2a1 1 0 0 1 1 1v1h6V3a1 1 0 0 1 2 0v1h1a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h1V3a1 1 0 0 1 1-1ZM7 6H6a1 1 0 0 0-1 1v3h14V7a1 1 0 0 0-1-1h-1v1a1 1 0 0 1-2 0V6H9v1a1 1 0 0 1-2 0Zm12 6H5v7a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1ZM7 15a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1Z" />
  </Icon>
);

export default Calendar;
